/* global axios */
import ApiClient from '../ApiClient';

class CampaignsBroadcast extends ApiClient {
  constructor() {
    super('campaign_logs', { accountScoped: true, apiVersion: 'v3' });
  }

  get(params) {
    return axios.get(`${this.url}/failure`, {
      params: {
        since: params.since,
        until: params.until,
        campaign_id: params.campaign_id,
        inbox_id: params.inbox_id,
        content: params.content,
        page: params.pageIndex,
      },
    });
  }

  getCampaignsEngagement(params) {
    return axios.get(`${this.url}/engagement`, {
      params: {
        since: params.since,
        until: params.until,
        campaign_id: params.campaign_id,
        inbox_id: params.inbox_id,
        page: params.pageIndex,
        content: params.content,
      },
    });
  }

  downloadEngagement(params) {
    return axios.get(`${this.url}/download/engagement`, {
      params: {
        since: params.since,
        until: params.until,
        campaign_id: params.campaign_id,
        inbox_id: params.inbox_id,
      },
    });
  }

  downloadFailed(params) {
    return axios.get(`${this.url}/download/failed`, {
      params: {
        since: params.since,
        until: params.until,
        campaign_id: params.campaign_id,
        inbox_id: params.inbox_id,
      },
    });
  }
}

export default new CampaignsBroadcast();
